import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const Profile = lazy(() => import('../../pages/user/profile/Profile'));
const CustomerList = lazy(() => import('../../pages/users/customer/CustomerList'));
const CustomerDetails = lazy(() => import('../../pages/users/customer/CustomerDetails'));
const AddCustomer = lazy(() => import('../../pages/users/customer/AddCustomer'));
const UpdateCustomer = lazy(() => import('../../pages/users/customer/UpdateCustomer'));
const MemberList = lazy(() => import('../../pages/users/member/MemberList'));
const AgronomyList = lazy(() => import('../../pages/users/agronomy/AgronomyList'));
const SupervisorList = lazy(() => import('../../pages/users/supervisor/SupervisorList'));
const StaffList = lazy(() => import('../../pages/users/staff/StaffList'));

export const UsersImport = {
    RoutesMap,
    Profile,
    CustomerList,
    CustomerDetails,
    AddCustomer,
    UpdateCustomer,
    MemberList,
    AgronomyList,
    SupervisorList,
    StaffList,
}